<template>
	<div class="allback">
		<div class="zy_content content-nav">
			<img src="@/images/nav_img.png" />
			<span>平台搜索</span>
		</div>
		<el-container class="content">
			<div class=" zy_content clearfix">
				<div class="zy_index_title">
					<img src="@/images/title_back1.png" class="zy_index_titleback" />
					<img src="@/images/zy-title9.png" class="zy_index_titlename" />
					<div class="zy_index_titleright clearfix">
						<div class="zy_index_titlerightinput clearfix">
							<el-input placeholder="请输入内容" @input='getDataList' clearable prefix-icon="el-icon-search" v-model='name' size='small' style='width: 100%;float: left;'></el-input>
						</div>
					</div>
				</div>
				<div class="zy_maincont clearfix">
					<el-tabs type="border-card" v-model="activeName">
						<el-tab-pane label="课程搜索" name='first'>
							<div v-if="!courseList || courseList.length<=0" class="simulation_empty_msg_content">暂无课程</div>
							<div class="clearfix">
								<div class="zy_courseitem" v-for="(item,index) in courseList">
									<img src="@/images/course_back.png" class="zy_course_back" />
									<div class="zy_course_cont">
										<div class="zy_course_img">
											<img :src="baseurl + item.banner" />
										</div>
										<div class="zy_course_info">
											<div class="zy_course_title">{{item.name}}</div>
											<div class="zy_course_P1">主讲人：{{item.username}}</div>
											<div class="zy_course_P2 text-ellipsistwo">简介：{{item.info}}</div>
											<div class="zy_course_P3 clearfix">
												<img src="@/images/zy_course_in.png" class="l" @click="toCourseindex(item)" />
												<span class="r">
													<i class="el-icon-s-custom"></i>{{addCount(item) || 0}}人已学习
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</el-tab-pane>
						<el-tab-pane label="作业搜索" name='second'>
							<div v-if="!taskList || taskList.length<=0" class="simulation_empty_msg_content">暂无作业</div>
							<div class="clearfix" v-if="taskList && taskList.length>0">
								<el-table :data="taskList" stripe style="width: 100%;margin: 0 0 20px 0;">
									<el-table-column prop="name" label="作业名称">
										<template slot-scope="scope">
											<span style="color: red;margin: 0 5px 0 0 ;" v-show='getNew(scope.row)'>[新]</span>{{scope.row.name}}
										</template>
									</el-table-column>
									<el-table-column label="创建时间" align="center">
										<template slot-scope="scope">
											{{scope.row.createTime | spliceForTask}}
										</template>
									</el-table-column>
									<el-table-column prop="createUsername" label="发布人" align="center">
									</el-table-column>
									<el-table-column prop="topicNum" label="题目数量" align="center">
									</el-table-column>
									<el-table-column prop="sumScore" label="总分" align="center">
									</el-table-column>
									<el-table-column prop="passScore" label="及格分" width='100' align="center">
					</el-table-column>
									<el-table-column label="操作" width='200' align="center">
										<template slot-scope="scope">
											<el-button size="mini" type="primary" @click="start(scope.row)" v-if='!scope.row.isFinish'>进入作业</el-button>
											<el-button size="mini" type="primary" @click="info(scope.row.id)" v-if='scope.row.isFinish'>查看结果</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-tab-pane>
						<el-tab-pane label="考试搜索" name='third'>
							<div v-if="!examList || examList.length<=0" class="simulation_empty_msg_content">暂无考试</div>
							<div class="clearfix" v-if="examList && examList.length>0">
								<el-table :data="examList" stripe>
									<el-table-column prop="name" label="考核名称">
									</el-table-column>
									<el-table-column prop="date" label="考核时间" align="center">
										<template slot-scope="scope">
											{{scope.row.beginTime | spliceForTask}} 至 {{scope.row.endTime | spliceForTask}}
										</template>
									</el-table-column>
									<el-table-column prop="timeSpent" label="限定时间" width='100' align="center">
										<template slot-scope="scope">
											{{scope.row.timeSpent || '-'}}
										</template>
									</el-table-column>
									<el-table-column prop="state" label="状态" width='100' align="center">
										<template slot-scope="scope">
											<el-tag type='primary' v-if='scope.row.state == 0'>考试中</el-tag>
											<el-tag type='success' v-if='scope.row.state == 1'>考核结束</el-tag>
											<el-tag type='info' v-if='scope.row.state == 2'>考试异常</el-tag>
											<el-tag type='danger' v-if='scope.row.state == 3'>未参考</el-tag>
										</template>
									</el-table-column>
									<el-table-column label="操作" width='250' align="center">
										<template slot-scope="scope">
											<el-button size="mini" type="success" v-if='scope.row.state == 1' v-show="scope.row.isCollection == '0'" @click="collectionExamine(scope.row,scope.$index)">收藏</el-button>
											<el-button size="mini" type="success" v-if='scope.row.state == 1' v-show="scope.row.isCollection == '1'" @click="collectionExamine(scope.row,scope.$index)">取消收藏</el-button>
											<el-button v-if='scope.row.state == 0' size="mini" type="primary" @click="startexamine(scope.row)" :disabled='getDisabld(scope.row)'>{{getDisabld(scope.row)?'不在考核时间内':'进入考核'}}</el-button>
											<el-button v-if='scope.row.state == 3' size="mini" type="primary" @click="startexamine(scope.row)" :disabled='getDisabld(scope.row)'>{{getDisabld(scope.row)?'不在考核时间内':'进入考核'}}</el-button>
											<el-button v-if='scope.row.state == 1' size="mini" type="primary" @click="examineit(scope.row)">查看详情</el-button>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</el-tab-pane>
					</el-tabs>

				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import { getStorageToken } from '@/utils/auth'
	import { platformSearch } from '@/api/course'
	import { collectionSave, collectionDelete } from '@/api/collection'
	export default {
		data() {
			return {
				name: this.$route.query.name || '',
				activeName: 'first',
				courseList: [],
				taskList: [],
				examList: [],
			}
		},
		created() {
			this.getDataList();
		},
		mounted() {

		},
		methods: {
			addCount(item){
				var count =0
				if(item.count && !Number.isNaN(count)){
					count = item.count*1
				}
				var addNumber = 800;
				if(item.name == '针灸学' || item.name == '推拿学'){
					addNumber = 2000;
				}else if(item.name == '传统养生功法' || item.name == '保健按摩'){
					addNumber = 900;
				}else if(item.name == '推拿手法' || item.name == '足反射疗法'){
					addNumber = 1000;
				}
				return count+addNumber
			},
			getDataList() {
				var data = {
					parameter: this.name,
					majorId: this.majorIdForAll,
				}
				platformSearch(data).then(res => {
					if(res.code == 0 && res.data) {
						this.courseList = res.data.course || [];
						this.examList = res.data.examine || [];
						this.taskList = res.data.task || [];
					}
				})
			},
			getNew(item) {
				if(item.beginTime && item.endTime) {
					var nowTime = new Date();
					var beginTime = new Date(item.beginTime.split('T').join(' '));
					var endTime = new Date(item.endTime.split('T').join(' '));
					if(nowTime < beginTime) {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			},
			toCourseindex(item) {
				var token = getStorageToken();
				if(token) {
					this.$router.push({
						name: 'courseindex',
						query: {
							id: item.id
						}
					})
				} else if(item.publicWelfare == '1') {
					this.$router.push({
						name: 'courseindexpublic',
						query: {
							id: item.id
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			start(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime.split('T').join(' '));
				var endTime = new Date(item.endTime.split('T').join(' '));
				if(nowTime < beginTime) {
					this.$message({
						type: 'info',
						message: '作业时间未到！',
					})
					return;
				}
				if(nowTime > endTime && item.isDelay == '0') {
					this.$message({
						type: 'info',
						message: '作业时间已结束！',
					})
					return;
				}
				this.$router.push({
					name: 'task',
					query: {
						taskId: item.id
					}
				})
			},
			info(id) {
				this.$router.push({
					name: 'taskdetails',
					query: {
						taskId: id
					}
				})
			},
			getDisabld(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime.split('T').join(' '));
				var endTime = new Date(item.endTime.split('T').join(' '));
				if(nowTime > beginTime && nowTime < endTime) {
					return false
				} else {
					return true
				}
			},
			startexamine(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime.split('T').join(' '));
				var endTime = new Date(item.endTime.split('T').join(' '));
				if(nowTime < beginTime) {
					this.$message({
						type: 'info',
						message: '考试时间未到！',
					})
					return;
				}
				if(nowTime > endTime) {
					this.$message({
						type: 'info',
						message: '考试时间已结束！',
					})
					return;
				}
				this.$router.push({
					name: 'examine',
					query: {
						id: item.id
					}
				})
			},
			examineit(item) {
				this.$router.push({
					name: 'examdetails',
					query: {
						id: item.id
					}
				})
			},
			collectionExamine(item, index) {
				if(item.isCollection != '1') {
					collectionSave({
						type: 'examine',
						typeId: item.id
					}).then(res => {
						if(res.success == true) {
							this.$message({
								type: 'success',
								message: "收藏成功!",
							})
							this.examList[index].isCollection = '1'
						} else {
							this.$message({
								type: 'error',
								message: res.data.message,
							})
						}
					})
				} else {
					collectionDelete({
						type: 'examine',
						typeId: item.id
					}).then(res => {
						if(res.success == true) {
							this.$message({
								type: 'success',
								message: '取消成功!'
							});
							this.examList[index].isCollection = '0'
						}
					})
				}
				this.collectState = !this.collectState
			},
		},
	}
</script>